'use client';

import React, { useState } from 'react';
import LoginBranding from './LoginBranding';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';

export type UserRole = 'student' | 'teacher' | 'admin';

export default function LoginPage() {
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex">
      {/* Left branding panel */}
      <LoginBranding />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 bg-white min-h-screen overflow-y-auto">
        <div className="w-full max-w-md">
          {/* GOGI Logo */}
          <div className="flex justify-center mb-8">
            <img
              src="/assets/images/GOGI_technology_education_logo-1775573318396.png"
              alt="GOGI App Logo"
              className="h-40 w-auto object-contain"
            />
          </div>

          {/* Mode toggle */}
          <div className="flex bg-slate-100 rounded-2xl p-1 mb-8">
            <button
              onClick={() => setAuthMode('login')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                authMode === 'login' ?'bg-white text-violet-700 shadow-sm' :'text-slate-500 hover:text-slate-700'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setAuthMode('signup')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                authMode === 'signup' ?'bg-white text-violet-700 shadow-sm' :'text-slate-500 hover:text-slate-700'
              }`}
            >
              Create Account
            </button>
          </div>

          {authMode === 'login' ? <LoginForm /> : <SignUpForm onSwitch={() => setAuthMode('login')} />}
        </div>
      </div>
    </div>
  );
}